export default "__VITE_ASSET__B9J0z6_j__"